import SearchFiltersBlock from './searchFiltersBlock'

export default SearchFiltersBlock
